export default __webpack_public_path__ + "static/media/starLBIcon.76534a1b.svg";